(function () {
  var LOG = '[cpf-validation]';

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.log.apply(console, args);
  }

  function warn() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift(LOG);
    console.warn.apply(console, args);
  }

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getConfig() {
    var root = document.querySelector('[data-cpf-validation]');
    if (!root) return null;

    var apiUrl = (root.getAttribute('data-api-url') || '').trim();
    var productId = (root.getAttribute('data-product-id') || '').trim();
    var enabled = root.getAttribute('data-enabled') === 'true';

    if (!enabled || !apiUrl || !productId) return null;

    return {
      apiUrl: apiUrl.replace(/\/$/, ''),
      productId: productId,
      msgExists:
        root.getAttribute('data-msg-exists') ||
        'Este CPF já possui inscrição neste evento. Cada atleta pode se inscrever apenas uma vez.',
      msgApiError:
        root.getAttribute('data-msg-api-error') ||
        'Não foi possível verificar o CPF no momento. Tente novamente.',
    };
  }

  function fetchDuplicate(cpf, config) {
    var separator = config.apiUrl.indexOf('?') >= 0 ? '&' : '?';
    var url =
      config.apiUrl +
      separator +
      'cpf=' +
      encodeURIComponent(cpf) +
      '&product_id=' +
      encodeURIComponent(config.productId);

    return fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) {
            throw new Error((body && body.error) || 'Erro na API');
          }
          return body;
        });
      });
  }

  window.validateCpfDuplicate = function (cpfValue) {
    if (window.cpfValidationEnabled === false) {
      return Promise.resolve({ exists: false, skipped: true });
    }

    var config = getConfig();
    if (!config) {
      return Promise.resolve({ exists: false, skipped: true });
    }

    var cpf = digitsOnly(cpfValue);
    if (cpf.length !== 11) {
      return Promise.resolve({ exists: false, skipped: true, reason: 'invalid-format' });
    }

    return fetchDuplicate(cpf, config)
      .then(function (body) {
        var exists = !!(body && (body.exists === true || body.found === true || body.cadastrado === true));
        return {
          exists: exists,
          message: exists ? config.msgExists : null,
          raw: body,
        };
      })
      .catch(function (error) {
        warn('API error', error);
        return {
          exists: false,
          error: true,
          message: config.msgApiError,
        };
      });
  };

  function boot() {
    var config = getConfig();
    if (!config) {
      warn('desabilitado ou config incompleta — ative em Tema > Configurações > Validação CPF');
      return;
    }
    log('ativo', { apiUrl: config.apiUrl, productId: config.productId });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
